import {
	SHOW_OVERLAY,
	HIDE_OVERLAY
} from "../constants"

const initialState = {
	message: ''
};

export const OverlayReducer = ( state = initialState, action ) => {
	switch ( action.type ) {
		case SHOW_OVERLAY :
			state = {
				...state,
				message: action.payload.message,
			};
			break;
		case HIDE_OVERLAY :
			state = initialState;
			break;
		default:

			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/reducers/overlay.js